import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "logout-wrapper" }
const _hoisted_2 = { class: "logout-container" }
const _hoisted_3 = { class: "logout-card text-center" }
const _hoisted_4 = { class: "logout-body" }
const _hoisted_5 = { class: "redirect-info" }
const _hoisted_6 = { class: "d-flex flex-column gap-2 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"card-header border-0 mb-3\" data-v-03a943d0><div class=\"logout-icon-wrapper mb-3\" data-v-03a943d0><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" fill=\"currentColor\" class=\"bi bi-box-arrow-right logout-icon\" viewBox=\"0 0 16 16\" data-v-03a943d0><path fill-rule=\"evenodd\" d=\"M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z\" data-v-03a943d0></path><path fill-rule=\"evenodd\" d=\"M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z\" data-v-03a943d0></path></svg></div><h2 class=\"auth-title\" data-v-03a943d0>Signed Out</h2><p class=\"auth-subtitle\" data-v-03a943d0>You have successfully logged out of your session.</p></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            _cache[2] || (_cache[2] = _createTextVNode(" Redirecting to sign in page in ")),
            _createElementVNode("strong", null, _toDisplayString(_ctx.countdown), 1),
            _cache[3] || (_cache[3] = _createTextVNode(" seconds... "))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToLogin && _ctx.goToLogin(...args))),
              class: "btn-submit"
            }, " Sign In Again "),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args))),
              class: "btn-secondary-link"
            }, " Return to Home Page ")
          ])
        ])
      ])
    ])
  ]))
}